import { render, staticRenderFns } from "./AddTruckFreeDialog.vue?vue&type=template&id=0915b906&scoped=true"
import script from "./AddTruckFreeDialog.vue?vue&type=script&lang=js"
export * from "./AddTruckFreeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddTruckFreeDialog.vue?vue&type=style&index=0&id=0915b906&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915b906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0915b906')) {
      api.createRecord('0915b906', component.options)
    } else {
      api.reload('0915b906', component.options)
    }
    module.hot.accept("./AddTruckFreeDialog.vue?vue&type=template&id=0915b906&scoped=true", function () {
      api.rerender('0915b906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/AddTruckFreeDialog.vue"
export default component.exports